import { createRepository } from '@/shared/repositories/Repository'
import { BASE_URL, GET_USER_INFO, SET_EMAIL_PATH } from '@/shared/api'
import type { UserInfoApiResponse } from '../model/types'
import type { SetEmailResponse } from '@/entities/Payment/model/types'

const userRepository = createRepository({
  basePath: BASE_URL,
  useAuth: true
})

export const getUserInfo = () => {
  return userRepository.get<UserInfoApiResponse>(
    GET_USER_INFO,
    undefined,
    {
      401: 'Необходима авторизация',
      403: 'Доступ запрещен',
      404: 'Пользователь не найден',
    }
  )
}

export const updateUserEmail = (email: string) => {
  return userRepository.post<SetEmailResponse, { email: string }>(
    SET_EMAIL_PATH,
    { email },
    {
      400: 'Некорректный email',
      401: 'Необходима авторизация',
      403: 'Доступ запрещен',
      422: 'Ошибка валидации email',
    }
  )
}
